import { ProfileFormPage } from '@/components/ProfileFormPage'

export const ProfileRegisterPage = () => <ProfileFormPage mode="register" />
